import { Component, Input } from '@angular/core';

@Component({
  selector: 'globot-email-password',
  templateUrl: './email-password.component.html',
  styleUrls: ['./email-password.component.scss'],
})
export class EmailPasswordComponent {
  @Input() content: string = '';
}
